<template>
    <div class="flex flex-col gap-4 md:mb-6">
        <!-- Mobile Main Image -->
        <div class="w-full bg-white border border-border rounded-lg p-4 flex items-center justify-center aspect-square overflow-hidden relative">

            <!-- Imagen Principal -->
            <template v-if="selectedProduct.images && selectedProduct.images.length > 0">
                <img 
                    :src="selectedProduct.images[currentImageIndex] ? selectedProduct.images[currentImageIndex].image : selectedProduct.images[0].image" 
                    :alt="selectedProduct.name"
                    fetchpriority="high"
                    class="w-full h-full object-contain mix-blend-multiply"
                />
            </template>
            <template v-else>
                <img 
                    :src="noImagePath" 
                    alt="No image available"
                    fetchpriority="high"
                    class="w-full h-full object-contain mix-blend-multiply opacity-50"
                />
            </template>
        </div>

        <!-- Mobile Thumbnails (Scroll Horizontal) 
        <template v-if="selectedProduct.images && selectedProduct.images.length > 1">
            <div class="flex gap-2 overflow-x-auto pb-2 snap-x">
                <button 
                    v-for="(image, index) in selectedProduct.images" 
                    :key="index"
                    @click="currentImageIndex = index"
                    class="w-16 aspect-square shrink-0 rounded-md p-1 bg-white overflow-hidden snap-start"
                    :class="currentImageIndex === index ? 'border-2 border-primary' : 'border border-border opacity-80'"
                >
                    <img 
                        :src="image.thumbnail || image.image" 
                        :alt="selectedProduct.name + ' view ' + (index + 1)"
                        loading="lazy"
                        class="w-full h-full object-contain mix-blend-multiply" 
                    />
                </button>
            </div>
        </template>
        -->
    </div>
</template>

<script>
export default {
    name: 'MobileImages',
    props: {
        selectedProduct: {
            type: Object,
            required: true
        },
        noImagePath: {
            type: String,
            default: '/front/img/product_images/no-image.jpg'
        }
    },
    data() {
        return {
            currentImageIndex: 0
        };
    },
    watch: {
        selectedProduct() {
            this.currentImageIndex = 0;
        }
    }
}
</script>